import React from 'react';
import PropTypes from 'prop-types';
import { getClassName } from '../../../utils/InputValidation';
import Label from '../Label/Label';
import '../Fields.scss';

const renderTextarea = ({
  optional,
  input,
  name,
  label,
  type,
  meta: { touched, invalid, visited, },
  rows,
}) => {
  return (
    <div className="input-wrapper input-wrapper--textarea">
      { label && <Label optional={optional} name={name} label={label} /> }
      <textarea {...input} type={type} className={getClassName(touched, invalid, visited)} rows={rows} />
    </div>
  );
};

renderTextarea.propTypes = {
  input: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  name: PropTypes.string,
  optional: PropTypes.bool,
  label: PropTypes.string,
  rows: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.bool
    ]),
  }).isRequired,
};

export default renderTextarea;
